export const EXPORT_LABELS = {
    ORDER_AT: "Order At",
    CREATED_AT: "Created At",
    REGISTERED_ON: "Registered On",
    PROFIT_DATE: "Profit Date",
    LAST_LOGIN_AT: "Last Login At",
    TOPUP_BEFORE: "Topup Before",
    TOPUP_AFTER: "Topup After",
};